import { Button, useToast } from '@hkdevs/design-system';
import { useCheck, useDownloadStatement } from '../../api/queries/pay';
import { downloadBlob } from '../payHistory/csv';
import { withReference } from '../../api/withReference';

/**
 * Check detail's "Download statement" (pc-o19.4): the check as a PDF, rendered by the
 * API. Shown once the check has loaded (there's no statement for a date with no check).
 */
export function DownloadStatement({ payDate, repId }: { payDate: string; repId?: string }) {
  const check = useCheck(payDate, repId);
  const statement = useDownloadStatement();
  const { toast } = useToast();
  if (!check.data) return null;

  const download = () =>
    statement.mutate(
      { payDate, repId },
      {
        onSuccess: ({ blob, fileName }) => downloadBlob(blob, fileName),
        onError: (error) =>
          toast(
            withReference(
              {
                tone: 'danger',
                title: 'The statement couldn’t be downloaded',
                description: 'Check your connection and try again.',
              },
              error,
            ),
          ),
      },
    );

  return (
    <Button
      size="sm"
      variant="secondary"
      leadingIcon="download"
      loading={statement.isPending}
      loadingText="Preparing…"
      onClick={download}
    >
      Download statement
    </Button>
  );
}
